import styled from "styled-components"

export const TableContainer = styled.div`
    width: 100%;
    height: 500px;
    overflow: auto;
    background: white;
    border-radius: 12px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
    border: 1px solid #e2e8f0;
`

export const StyledTable = styled.table`
    width: 100%;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0;
`

export const ColumnGroup = styled.colgroup`
    .col-1, .col-2, .col-3 { width: 200px; }
    .col-4, .col-5 { width: 130px; }
`

export const TableHeader = styled.thead`
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #f8fafc;
`

export const HeaderRow = styled.tr`
    &:first-child {
        th {
            padding: 12px 10px;
            font-size: 13px;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            border-bottom: 1px solid #e2e8f0;
            background-color: #f1f5f9;
        }
    }

    &:last-child {
        th {
            padding: 10px 10px;
            font-size: 12px;
            border-bottom: 2px solid #cbd5e0;
            background-color: #f8fafc;
        }
    }
`

export const HeaderCell = styled.th`
    text-align: left;
    color: #334155;
    font-weight: 600;
`

export const TableBody = styled.tbody`
    /* Custom styling for table body */
`

export const TableRow = styled.tr`
    transition: background-color 0.2s;

    &:hover {
        background-color: #f1f5f9;
    }
`

export const LocationRow = styled(TableRow)`
    background-color: #e6f0ff;
    position: sticky;
    top: 83px;
    cursor: pointer;
    
    &.selected {
        background-color: #dbeafe;
        border-left: 4px solid #3b82f6;
    }
    
    &:hover {
        background-color: #dbeafe;
    }
`

export const ProductRow = styled(TableRow)`
    background-color: #fff;
    
    &:nth-child(even) {
        background-color: #f8fafc;
    }
    
    &:hover {
        background-color: #f1f5f9;
    }
`

export const TableCell = styled.td`
    padding: 10px 10px;
    border-bottom: 1px solid #e2e8f0;
    color: #334155;
    font-size: 12px;
    line-height: 1.5;

    &.bold {
        font-weight: 700;
    }

    &.handlerCell {
        display: flex;
        align-items: center;   
        gap: 8px;
    }
    
    mark {
        background-color: #fef08a;
        padding: 1px 2px;
        border-radius: 2px;
    }
`

export const StatusBadge = styled.span`
    padding: 4px 10px;
    border-radius: 9999px;
    font-size: 11px;
    font-weight: 600;
    display: inline-block;
    
    ${({ $status }) =>
      $status === "y"
        ? `
        background-color: #dcfce7;
        color: #166534;
    `
        : `
        background-color: #fee2e2;
        color: #b91c1c;
    `}
`

export const ActionButton = styled.button`
    background-color: #3b82f6;
    color: white;
    border: none;
    padding: 4px 12px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 12px;
    font-weight: 500;

    &:hover {
        background-color: #2563eb;
        transform: translateY(-1px);
    }
    
    &:active {
        transform: translateY(0);
    }
    
    &.addButton {
        background-color: #4f46e5;
        
        &:hover {
            background-color: #4338ca;
        }
    }

    &.backupButton{
        color: #333;
        background-color: #e0e0e0;
        
        &:hover {
            background-color: #d0d0d0;
        }
    }
`
